import { render, staticRenderFns } from "./ExPhotography.vue?vue&type=template&id=4e950618&scoped=true&"
import script from "./ExPhotography.vue?vue&type=script&lang=js&"
export * from "./ExPhotography.vue?vue&type=script&lang=js&"
import style0 from "./ExPhotography.vue?vue&type=style&index=0&id=4e950618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e950618",
  null
  
)

export default component.exports